import * as React from "react";
import {OrderDashboard} from "../OrderDashboard/OrderDashboard";
import {useState} from "react";
import {SlideMenu} from "./SlideMenu";
import {SearchBar} from "../SearchBar/SearchBar";

declare const ViewUsername: string;
declare const isDispatcher: boolean;

export function MobileNavbar() {
    const [showSlideMenu, setShowSlideMenu] = useState(false);
    let pathPieces = window.location.pathname.split("/");
    let controller = pathPieces[1];
    let action = pathPieces.length > 3 ? pathPieces[2] : null;

    return (
        <div className="mobile-nav">
            <div id="guest-mount-1"/>
            <div id="guest-mount-2"/>
            <div className="main">
                <a href="/OrderDashboard" className={controller == 'OrderDashboard' ? 'link active' : 'link'}>
                    <span className="fas fa-file-alt"/>
                    <span>Orders</span>
                </a>
                {
                    isDispatcher &&
                    <a href="/TripDashboard" className={controller == 'TripDashboard' && action == null ? 'link active' : 'link'}>
                        <span className="fas fa-route"/>
                        <span>Trips</span>
                    </a>
                }
                <div className="dropdown flex-grow-1">
                    <div className="link" id="mobile-nav-menu-button"
                         data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="fas fa-bars"/>
                        <span>Menu</span>
                    </div>
                    <div className="dropdown-menu" aria-labelledby="mobile-nav-menu-button">
                        <a className="dropdown-item" href={`/TripDashboard/Ltc`}>Trips (Beta)</a>
                        <a className="dropdown-item" href={`/QuickDispatch?redirectUrl=${window.location}`}>Quick Dispatch</a>
                        <a className="dropdown-item" href={`/Dispatch`}>Schedule</a>
                        <div className="dropdown-divider"/>
                        <a className="dropdown-item" href="#" onClick={() => {
                            setShowSlideMenu(true)
                        }}>Lookup Tool</a>
                        <a className="dropdown-item" href={`/Order/FromPackageBarcode`}>Scan Packages</a>
                        <a className="dropdown-item" href={`/Order/FromBarcode`}>Scan Orders</a>
                        <div className="dropdown-divider"/>
                        <div className="text-muted pl-4 fa-sm"><span
                            className="far fa-user-circle mr-1"/>{ViewUsername ?? "Account"}</div>
                        <a className="dropdown-item" href="/Account/Logout">Logout</a>
                    </div>
                </div>
                {showSlideMenu && <SlideMenu children={<SearchBar/>}
                                             title={'Lookup Tool'}
                                             onDismissedFunction={() => setShowSlideMenu(false)}/>}
            </div>
        </div>
    )
};